import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/attendance/AttendanceAction";
import {
  DeleteButton,
  attendanceDeletionAlert,
  getAuthorities,
  getDateFormat,
  redirectToPages,
  resultAlert
} from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { StudentsPage } from "./students/StudentsPage";

export function SectionAttendanceDetail({
  history,
  match: {
    params: { sectionId, date, courseHour }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  
  // Getting curret state of Section Attendance Details from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, authorities, section, teacher, attendanceTime, courseStartHour } = useSelector(
    (state) => ({
      actionsLoading: state.attendance.actionsLoading,
      isSuccess: state.attendance.isSuccess,
      type: state.attendance.type,
      authorities: state.attendance.authorities,
      section: state.attendance.section,
      teacher: state.attendance.teacher,
      attendanceTime: state.attendance.attendanceTime,
      courseStartHour: state.attendance.courseStartHour
    }),
    shallowEqual
  );

  // Authority Parameters
  const { isDeletionAuthorized } = getAuthorities(authorities);

  useEffect(() => {
    dispatch(actions.getAttendanceDetails(sectionId, date, courseHour));
    return () => dispatch(actions.cleanAttendanceState());
  }, [dispatch, sectionId, date, courseHour]);
  
  useEffect(() => {
    let _title = "Sınıf Yoklama Detayı";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Mevcut Sınıf Yoklamasını Siler */
  const deleteAttendance = () => {
    attendanceDeletionAlert().then(result => {
      if (result.isConfirmed) dispatch(actions.deleteAttendance({ sectionId, date, courseHour })).then(result => onResult(result))});
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/sinif-yoklamalari"), 2500);
  };

  return (
    <>
      <Card>
        { actionsLoading && <ModalProgressBar /> }
        <CardHeader title={title}>
          {
            isDeletionAuthorized &&
            <CardHeaderToolbar>
              <DeleteButton
                title="Yoklamayı Sil"
                method={deleteAttendance}
              />
            </CardHeaderToolbar>
          }
        </CardHeader>
        <CardBody>
          <div className="form-group row">
            <div className="col-1">
              <b>Sınıf:</b>
            </div>
            <div className="col-4">
              {section}
            </div>
            <div className="col-2">
              <b>Tarih:</b>
            </div>
            <div className="col-4">
              {getDateFormat(date).replaceAll("-", ".")}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-1">
              <b>Ders:</b>
            </div>
            <div className="col-4">
              {courseHour}. Ders ({courseStartHour})
            </div>
            <div className="col-2">
              <b>Yoklama Saati:</b>
            </div>
            <div className="col-4">
              {attendanceTime}
            </div>
          </div>

          <div className="form-group row">
            <div className="col-1">
              <b>Öğretmen:</b>
            </div>
            <div className="col-4">
              {teacher}
            </div>
          </div>
        </CardBody>
      </Card>
      <StudentsPage
        date={date}
        section={section}
        sectionId={sectionId}
        courseHour={courseHour}
      />
    </>    
  );
}